import React from 'react'
import PropTypes from 'prop-types'
// import { FormattedMessage } from 'react-intl'
// import classNames from 'classnames'

class HowItWorks extends React.Component {
  closeClicked(e) {
    e.preventDefault()
    const { toggle } = this.props

    toggle()
  }

  render() {
    // const { opened } = this.props

    return (
      null
      // <div className={classNames('how-it-works', { 'is-open': opened })}>
      //   <a href="#" onClick={this.closeClicked.bind(this)} className="how-it-works__close">
      //     <i className="icon--cross"></i>
      //   </a>
      //   <div className="wrap">
      //     <div className="how-it-works__content">
      //       <div className="grid">
      //         <div className="grid__item tab-6-12 lap-3-12">
      //           <div className="how-it-works__icon">
      //             <img src="/fonts/svg/booking-button_trova.svg" />
      //           </div>
      //           <h2 className="how-it-works__subtitle">
      //             <FormattedMessage id="app.how-it-works.find.title" />
      //           </h2>
      //           <p>
      //             <FormattedMessage id="app.how-it-works.find.description" />
      //           </p>
      //         </div>
      //         <div className="grid__item tab-6-12 lap-3-12">
      //           <div className="how-it-works__icon">
      //             <img src="/fonts/svg/booking-button_prenota.svg" />
      //           </div>
      //           <h2 className="how-it-works__subtitle">
      //             <FormattedMessage id="app.how-it-works.book.title" />
      //           </h2>
      //           <p>
      //             <FormattedMessage id="app.how-it-works.book.description" />
      //           </p>
      //         </div>
      //         <div className="grid__item tab-6-12 lap-3-12">
      //           <div className="how-it-works__icon">
      //             <img src="/fonts/svg/booking-button_degusta.svg" />
      //           </div>
      //           <h2 className="how-it-works__subtitle">
      //             <FormattedMessage id="app.how-it-works.join.title" />
      //           </h2>
      //           <p>
      //             <FormattedMessage id="app.how-it-works.join.description" />
      //           </p>
      //         </div>
      //         <div className="grid__item tab-6-12 lap-3-12">
      //           <div className="how-it-works__icon">
      //             <img src="/fonts/svg/booking-button_scarica.svg" />
      //           </div>
      //           <h2 className="how-it-works__subtitle">
      //             <FormattedMessage id="app.how-it-works.download.title" />
      //           </h2>
      //           <p>
      //             <FormattedMessage id="app.how-it-works.download.description" />
      //           </p>
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // </div>
    )
  }
}

HowItWorks.propTypes = {
  opened: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default HowItWorks
